import {BymoPageProps} from "../../client-server-common";
import {BymoPageContextProps} from "../../doppe-sdk";

export function doppeViewerShouldRemoveHoppBanner (
    bymoPageProps: Pick<BymoPageProps, 'removeHoppBanner'>,
    bymoPageContextProps: BymoPageContextProps
) {
    return bymoPageContextProps.viewerHideFooterBanner || bymoPageProps.removeHoppBanner
}